"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridSelectionRowRenderer = void 0;
function createGridSelectionRowRenderer(params) {
    return function renderGridRow(_a) {
        var _b, _c;
        var { originalRenderer } = _a, rest = __rest(_a, ["originalRenderer"]);
        if (!originalRenderer) {
            throw new Error('GridCore error: "originalRenderer" must be provided ');
        }
        const disabled = rest.disabled || !!((_b = params.isDisabled) === null || _b === void 0 ? void 0 : _b.call(params, rest.index));
        const selected = rest.selected || !!((_c = params.isSelected) === null || _c === void 0 ? void 0 : _c.call(params, rest.index));
        return originalRenderer(Object.assign(Object.assign({}, rest), { handlers: {
                onClick: (e) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    if (disabled) {
                        return;
                    }
                    if (e.shiftKey) {
                        e.preventDefault();
                        e.stopPropagation();
                        (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty();
                        (_b = params.onMultiSelect) === null || _b === void 0 ? void 0 : _b.call(params, rest.index, true);
                        (_c = params.onRowClick) === null || _c === void 0 ? void 0 : _c.call(params, rest.index);
                        return;
                    }
                    if (e.ctrlKey || e.metaKey) {
                        (_d = params.onMultiSelect) === null || _d === void 0 ? void 0 : _d.call(params, rest.index, false);
                        (_e = params.onRowClick) === null || _e === void 0 ? void 0 : _e.call(params, rest.index);
                        return;
                    }
                    if ((_f = window.getSelection()) === null || _f === void 0 ? void 0 : _f.isCollapsed) {
                        (_g = window.getSelection()) === null || _g === void 0 ? void 0 : _g.empty();
                    }
                    params.onSelect(rest.index);
                    (_h = params.onRowClick) === null || _h === void 0 ? void 0 : _h.call(params, rest.index);
                },
                onContextMenu: (e) => {
                    var _a;
                    if (!params.onContextMenu) {
                        return;
                    }
                    e.stopPropagation();
                    e.preventDefault();
                    (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty();
                    params.onContextMenu(rest.index, e);
                },
                onDoubleClick: (e) => {
                    var _a;
                    if (disabled) {
                        return;
                    }
                    (_a = params.onRowDoubleClick) === null || _a === void 0 ? void 0 : _a.call(params, rest.index);
                }
            }, selected,
            disabled }));
    };
}
exports.createGridSelectionRowRenderer = createGridSelectionRowRenderer;
//# sourceMappingURL=createGridSelectionRowRenderer.js.map